import { useSubscriptionApi } from '@hooks/api/account/useSubscriptionApi/useSubscriptionApi';
import { usePostApi } from '@hooks/api/usePostApi';
import type {
  ActiveSubscriptionItem,
  SubscriptionUpdateAddons,
} from 'types/account/subscriptions';
import type { PostApiOptions } from 'types/api';

export function useUpdateSubscriptionAddons(
  organizationId: string,
  subscriptionId = '',
  options?: Partial<
    PostApiOptions<ActiveSubscriptionItem, SubscriptionUpdateAddons>
  >
) {
  const api = useSubscriptionApi();

  const { post: updateSubscriptionAddons, isPosting: isUpdatingAddons } =
    usePostApi({
      getSuccessMessage: () => 'Subscription updated!',
      request: (params) => api.updateSubscriptionAddons(organizationId, params),
      ...options,
    });

  return {
    isUpdatingAddons,
    updateSubscriptionAddons: async (
      lineItems: SubscriptionUpdateAddons['lineItems'],
      paymentMethodId: string
    ) => {
      return updateSubscriptionAddons({
        paymentMethodId,
        lineItems,
        subscriptionId,
      });
    },
  };
}
